import { UseQueryResult, useQuery } from 'react-query'
import request from 'superagent'
import { getApiServer } from '../../utils/domain'

interface EnvironmentData {
    environment: string
    turnstileSiteKey: string;
    includeTotalInFHIRRequest: boolean;
    isSingleTenantServer: boolean;
    patientAccessEndpointURL: string;
    providerDirectoryEndpointURL: string;
    patientAccessDocumentationURL: string;
    providerDirectoryDocumentationURL: string;
    tenant: string;
    clientCarePlanType: string;
    showDrugLookup: boolean;
    serverSecurity: string;
    showAdminPasswordReset: boolean;
}

export default function useEnvironment(): UseQueryResult<EnvironmentData, unknown> {
    return useQuery<EnvironmentData, unknown>('environment', async () => {
        const environment = await request.get(`${getApiServer()}/environment`).set('Accept', 'application/json')
        return environment.body
    }, {
        staleTime: 3600000,
        cacheTime: 3600000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: 0,
    })
}